import styled, { css } from 'styled-components';
import { customMedia } from 'styles/utils';
import { BlockSize } from 'libs/rendering/gltf/config';
import {
  CADSidebarWidth,
  FrameHeaderHeight,
  MobileFrameHeaderHeight,
  cadRoomToolbarZIndex,
} from 'styles/constants';

import Icon from 'components/Icon';
import Button from 'components/Button';

const THUMB_SIZE = 16;
const THUMB_BORDER_SIZE = 4;

export const MainToolBar = styled.div`
  display: flex;
  position: absolute;
  z-index: ${cadRoomToolbarZIndex};
  ${customMedia.lessThan('medium')`
    display: none;
  `};

  background: ${props => props.theme.color.wfWhite};
  border-radius: 5px;
  height: 40px;
  left: calc(50% - ${CADSidebarWidth}px);
  top: ${props => props.top};
  bottom: ${props => props.bottom ?? `${FrameHeaderHeight * 2}px`};
  margin: ${props => props.margin ?? 'auto'};
  width: fit-content;
  box-shadow: 0px 4px 15px 0px ${props => props.theme.color.wfGrey800};
`;

export const ToolBarButtons = styled.nav`
  z-index: 1003;
  display: flex;
  justify-content: center;

  ul {
    display: flex;
    border: none;
    height: 100%;
    align-items: center;
  }

  button {
    border: none;
  }

  li {
    border: none;
  }

  svg {
    width: ${BlockSize.iconsSize};
    height: ${BlockSize.iconsSize};
  }

  ${customMedia.lessThan('medium')`
    transition: transform 1s ease;
  `};
`;

export const SliderWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  left: ${props => props.canvasWidth / 2 + 10}px;
  bottom: ${FrameHeaderHeight * 5}px;
  transform: translate(-50%);
  overflow: hidden;

  min-width: 260px;
  height: 29px;

  z-index: 10002;
  cursor: pointer;
  vertical-align: bottom;
  color: ${props => props.theme.color.greyDark};

  ${customMedia.lessThan('medium')`
    width: 100vw;
    top: ${MobileFrameHeaderHeight}px;
    left: 0;
    transform: translateX(0);
    border-left: 0;
    border-right: 0;
  `};
`;

const sliderThumb = css`
  width: ${THUMB_SIZE}px;
  height: ${THUMB_SIZE}px;
  border-radius: 50%;
  margin-top: -${(THUMB_SIZE + THUMB_BORDER_SIZE) / 2 + 1}px;
  background: #0f2eff;
  border: ${THUMB_BORDER_SIZE}px solid #fff;
  cursor: pointer;
  box-sizing: content-box;
`;

// FIXME: Move these styles into future INPUT/slider component. Is mandatory to review and refactor css rules.
export const SliderInput = styled.input`
  width: calc(100% - 35px);
  height: 100%;
  margin: 0 5px;
  vertical-align: top;
  margin-bottom: ${props => props.theme.spacing.small};
  -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
  background: transparent; /* Otherwise white in Chrome */
  box-shadow: none;
  /* Track styling for WebKit/Blink */
  &::-webkit-slider-runnable-track {
    height: 1px;
    cursor: pointer;
    background: #000;
  }
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    margin-top: -6px;
    ${sliderThumb}
  }

  /* Track styling for Firefox */
  &::-moz-range-track {
    height: 1px;
    cursor: pointer;
    background: #000;
  }
  &::-moz-range-thumb {
    ${sliderThumb}
  }

  /* Track styling for IE */
  &::-ms-track {
    height: 2px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    border-width: 16px 0;
    color: transparent;
  }

  &::-ms-fill-lower,
  &::-ms-fill-upper {
    background: #000;
    border-radius: 2px;
  }

  &::-ms-thumb {
    ${sliderThumb}
    margin-top: -6px;
  }
`;

export const SliderCloseButton = styled(Button)`
  height: 28px;
  width: 20px;
  margin-right: 5px;
  border-radius: 0px;
  background-color: transparent;
  color: #000;
  vertical-align: top;
  border: none;
  &:hover {
    background-color: transparent;
    color: ${props => props.theme.color.wfOrange};
  }
`;

export const ToolbarDialogStyled = styled.ul`
  font-size: ${props => props.theme.font.size.small};
  display: flex;
  flex-direction: column;
`;

export const ToolbarDialogOptionStyled = styled.li`
  display: flex;
  align-items: center;
  color: ${props =>
    props.active ? props.theme.color.primary : props.theme.color.wfBlack};
  padding: ${props => `0.5rem ${props.theme.spacing.default}`};
  &:not(:first-of-type) {
    border-top: 1px solid ${props => props.theme.color.wfGrey200};
  }
  &:hover {
    color: ${props => props.theme.color.primary};
    cursor: pointer;
  }
`;

export const IconStyled = styled(Icon)`
  margin-right: ${props => props.theme.spacing.small};
  margin-top: 1px;
`;

export const LabelStyled = styled.span`
  padding-right: ${props => props.theme.spacing.small};
`;
